/**
 * Qrew HR — ThemeProvider
 * Reads tenant's settings.* keys and writes them to CSS custom properties on
 * documentElement, plus data-attributes for sidebar mode and dashboard density.
 */
import { useEffect } from "react";
import { useAuth } from "@/lib/auth";

const VAR = {
  primary:        "--qh-primary",
  accent:         "--qh-accent",
  success:        "--qh-success",
  warning:        "--qh-warning",
  danger:         "--qh-danger",
  info:           "--qh-info",
  gradFrom:       "--qh-grad-from",
  gradVia:        "--qh-grad-via",
  gradTo:         "--qh-grad-to",
  btnText:        "--qh-btn-text",
  cardRadius:     "--qh-radius-card",
  btnRadius:      "--qh-radius-button",
};

export function ThemeProvider({ children }) {
  const { settings } = useAuth();

  useEffect(() => {
    const r = document.documentElement;
    const setVar = (name, val) => { if (val) r.style.setProperty(name, val); };

    setVar(VAR.primary,    settings?.primary_color);
    setVar(VAR.accent,     settings?.accent_color);
    setVar(VAR.success,    settings?.color_success);
    setVar(VAR.warning,    settings?.color_warning);
    setVar(VAR.danger,     settings?.color_danger);
    setVar(VAR.info,       settings?.color_info);
    setVar(VAR.gradFrom,   settings?.btn_gradient_from);
    setVar(VAR.gradVia,    settings?.btn_gradient_via);
    setVar(VAR.gradTo,     settings?.btn_gradient_to);
    setVar(VAR.btnText,    settings?.btn_text_color);
    setVar(VAR.cardRadius, settings?.card_radius);
    setVar(VAR.btnRadius,  settings?.btn_radius);

    // Shadow on/off
    if (settings && settings.btn_shadow === false) {
      r.style.setProperty("--qh-shadow-btn", "none");
    } else {
      r.style.removeProperty("--qh-shadow-btn");
    }

    // Sidebar mode + density via data attributes
    r.setAttribute("data-sidebar", settings?.sidebar_mode === "dark" ? "dark" : "light");
    const density = ["compact", "comfortable", "spacious"].includes(settings?.dashboard_density)
      ? settings.dashboard_density
      : "comfortable";
    r.setAttribute("data-density", density);

    // Heading font (already controlled by font_family on body)
  }, [settings]);

  return children;
}
